<template>
    <div class="mx-auto">
        <page-title :show-title="false" :title="$t('annualCatalog.annualCatalog')"></page-title>
        <div v-if="loading" class="loader"></div>
        <div class="card" v-if="!loading">
            <div>
                <div v-if="annualCatalog == null">
                    {{ $t('annualCatalog.noData') }}
                </div>
                <div v-else class="card-header bg-primary text-white">
                    <div class="h5">
                        {{ $t('annualCatalog.annualCatalog') }} - {{ annualCatalog.year }},
                        {{ $t('annualCatalog.approved') }}: {{ annualCatalog.approvedUser }}
                        {{ $t('annualCatalog.on') }}
                        {{ `${annualCatalog.createdDate.getDate()}.${annualCatalog.createdDate.getMonth() + 1}.${annualCatalog.createdDate.getFullYear()}` }}
                    </div>
                </div>
                <div class="card-body">
                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <th>{{ $t('planning.theme') }}</th>
                            <th>{{ $t('thematicArea.thematicArea') }}</th>
                            <th>{{ $t('planning.legalArea') }}</th>
                            <th>{{ $t('planning.lectorsProposal') }}</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item of annualCatalog.items">
                            <td>
                                {{ item.theme }}
                            </td>
                            <td>{{ item.thematicArea }}</td>
                            <td>
                                {{ item.legalArea }}
                            </td>
                            <td>
                                <span v-for="lector in item.lectors" :title="lector.email">
                                    {{ lector.fullName }} <br />
                                </span>
                            </td>
                            <td>
                                <button class="btn btn-primary" @click="createEvent(item.id)">Създай събитие</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PageTitle from '../../components/common/PageTitle';
    import { AnnualCatalogModel } from '../../models/models';

    export  default {
        components: {
            PageTitle
        },
        data() {
            return {
                loading: false,
                id: '',
                annualCatalog: null
            }
        },
        methods: {
            loadData() {
                this.$http.get(`/api/AnnualCatalog/GetById/${this.id}`).then(result => {
                    if (result) {
                        this.annualCatalog = new AnnualCatalogModel(result.data);
                    }
                }).catch(error => {
                    // TODO:
                });
            },
            createEvent(id) {
                this.$router.push({
                    name: 'events',
                    params: { annualCatalogItemId: id }
                });
            }
        },
        mounted () {
            this.id = this.$route.params.id;
            this.loadData();
        }
    }
</script>
